export const getSidFromQueryParams = (
  queryParams: NodeJS.Dict<string | string[]>
) => {
  return queryParams.sid as string | undefined;
};
